// Patient Details
const PATIENT_REQUEST = 'PATIENT_REQUEST';
const PATIENT_SUCCESS = 'PATIENT_SUCCESS';
const PATIENT_FAILURE = 'PATIENT_FAILURE';

// Patient List
const PATIENT_REQUEST_LIST = 'PATIENT_REQUEST_LIST';
const PATIENT_SUCCESS_LIST = 'PATIENT_SUCCESS_LIST';
const PATIENT_FAILURE_LIST = 'PATIENT_FAILURE_LIST';

// Upgrade Patient List
const PATIENT_REQUEST_UPGRADE = 'PATIENT_REQUEST_UPGRADE';
const PATIENT_SUCCESS_UPGRADE = 'PATIENT_SUCCESS_UPGRADE';
const PATIENT_FAILURE_UPGRADE = 'PATIENT_FAILURE_UPGRADE';

// Patient Getby Id
const PATIENT_REQUEST_GETBYID = 'PATIENT_REQUEST_GETBYID';
const PATIENT_SUCCESS_GETBYID = 'PATIENT_SUCCESS_GETBYID';
const PATIENT_FAILURE_GETBYID = 'PATIENT_FAILURE_GETBYID';

// Patient Update
const PATIENT_REQUEST_UPDATE = 'PATIENT_REQUEST_UPDATE';
const PATIENT_SUCCESS_UPDATE = 'PATIENT_SUCCESS_UPDATE';
const PATIENT_FAILURE_UPDATE = 'PATIENT_FAILURE_UPDATE';

// patient Delete
const PATIENT_REQUEST_DELETE = 'PATIENT_REQUEST_DELETE';
const PATIENT_SUCCESS_DELETE = 'PATIENT_SUCCESS_DELETE';
const PATIENT_FAILURE_DELETE = 'PATIENT_FAILURE_DELETE';

export {
    PATIENT_REQUEST, PATIENT_SUCCESS,PATIENT_FAILURE,PATIENT_REQUEST_LIST,PATIENT_SUCCESS_LIST,PATIENT_FAILURE_LIST,PATIENT_REQUEST_UPGRADE,PATIENT_SUCCESS_UPGRADE,PATIENT_FAILURE_UPGRADE,
    PATIENT_REQUEST_GETBYID,PATIENT_SUCCESS_GETBYID,PATIENT_FAILURE_GETBYID,PATIENT_REQUEST_DELETE,PATIENT_SUCCESS_DELETE,PATIENT_FAILURE_DELETE,
    PATIENT_REQUEST_UPDATE,PATIENT_SUCCESS_UPDATE,PATIENT_FAILURE_UPDATE

};